// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1mU9k","search":"Settings_search__2QFRC","filter":"Settings_filter__2cWN5"};